import classNames from 'classnames';
import { LabelBody } from './LabelBody';

type Props = {
    children?: React.ReactNode;
    className?: string;
    class?: string;
    text?: string;
    onClickHandler: (addToList: boolean) => void;
    isClicked: boolean;
};

export function MultipleChoiceButton({
    children,
    className,
    text,
    onClickHandler,
    isClicked,
    ...props
}: Props) {
    return (
        <button
            onClick={() => onClickHandler(!isClicked)}
            className={classNames(
                className,
                props.class,
                'snap-center rounded-[10px] border px-20 py-10 text-left',
                {
                    'border-vibrant-blue bg-vibrant-blue-10p': isClicked,
                    'border-line-light bg-white': !isClicked,
                },
            )}
        >
            <LabelBody
                class={isClicked ? 'text-dark-blue' : null}
                bold={isClicked}
            >
                {text ?? children ?? ''}
            </LabelBody>
        </button>
    );
}
